import moment from 'moment';

// DD-MM-YYYY HH:mm to YYYY-MM-DDTHH:mm:ss
export const reverseParseDate = (date: string | undefined) => {
    if (!date) return '';

    const parsed = moment(
        date,
        [
            'DD-MM-YYYY HH:mm:ss',
            'DD-MM-YYYY HH:mm',
            'YYYY-MM-DDTHH:mm:ss',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
            moment.ISO_8601
        ],
        true
    );

    return parsed.isValid() ? parsed.format('YYYY-MM-DDTHH:mm:ss') : '';
};

// string date to 'DD-MM-YYYY HH:mm' format
export const dateFormat = (fecha: string | undefined | null) => {
    if (fecha === undefined || fecha === null) return '';
    if (moment(fecha).isValid()) return moment(fecha).format('DD-MM-YYYY HH:mm');
    else return '';
};

// string date from 'DD-MM-YYYY HH:mm:SS' or 'HH:mm:SS' to 'DD-MM-YYYY HH:00:00'
export const removeMinutes = (date: string) => date.split(':')[0] + ':00';